import browserHistory from 'react-router/lib/browserHistory';
const TOKEN_KEY = 'thorgeneMwebGeneToken';
const APP_ID = 'appId';
const REPORT_TOKEN = 'reportToken';
const OWNER_ID = 'ownerId';
const PRODUCT_ID = 'productId';

const reg = /(\?|&)token=(.*?)(&|$)/;
const reg2 = /(\?|&)appid=(.*?)(&|$)/;
const reg3 = /(\?|&)reportToken=(.*?)(&|$)/;
const reg4 = /(\?|&)ownerId=(.*?)(&|$)/;
const reg5 = /(\?|&)productId=(.*?)(&|$)/;
const match1 = location.search.match(reg);
const match2 = location.search.match(reg2);
const match3 = location.search.match(reg3);
const match4 = location.search.match(reg4);
const match5 = location.search.match(reg5);

if (match1) {
  localStorage.setItem(TOKEN_KEY, match1[2]);
  browserHistory.replace({
    pathname: location.pathname,
    search: location.search.replace(/(\?|&)token=(.*?)(&|$)/, function () {
      if (arguments[1] === '?' && arguments[3] === '&') {
        return '?';
      }
      if (arguments[1] === '?' && arguments[3] === '') {
        return '';
      }
      if (arguments[1] === '&' && arguments[3] === '&') {
        return '&';
      }
      if (arguments[1] === '&' && arguments[3] === '') {
        return '';
      }
    })
  });
}

if (match2) {
  localStorage.setItem(APP_ID, match2[2]);
}
if (match3) {
  localStorage.setItem(REPORT_TOKEN, match3[2]);
}
if (match4) {
  localStorage.setItem(OWNER_ID, match4[2]);
}
if (match5) {
  localStorage.setItem(PRODUCT_ID, match5[2]);
}
export const saveItem = (key, value) => {
  localStorage.setItem(key, value);
};
export const token = localStorage.getItem(TOKEN_KEY) || 'empty_token';
export const appId = localStorage.getItem(APP_ID) || '';
// export const reportToken = localStorage.getItem(REPORT_TOKEN) || '';
// export const ownerId = localStorage.getItem(OWNER_ID) || '';
export const findItem = (key) => {
  return localStorage.getItem(key);
};



// WEBPACK FOOTER //
// ./src/lib/auth/token.js